import { useFormikContext } from 'formik';
import { useEffect } from 'react';

import { useDetailsContext } from '@providers/basket/DetailsProvider/Context';
import { validateEmail, validatePhoneNumber } from '@utils/validators';

import { SaveFormValues } from '../types';

const useLoadYourDetailsValues = () => {
  const {
    details: { aboutEmail, aboutContactNumber },
  } = useDetailsContext();
  const { setFieldValue } = useFormikContext<SaveFormValues>();

  useEffect(() => {
    if (aboutEmail && validateEmail(aboutEmail)) {
      setFieldValue('emails', [aboutEmail]);
    }

    if (aboutContactNumber && validatePhoneNumber(aboutContactNumber)) {
      setFieldValue('mobiles', [aboutContactNumber]);
    }
  }, [aboutContactNumber, aboutEmail, setFieldValue]);
};

export { useLoadYourDetailsValues };
